import React, { useEffect, useState, useRef } from "react";
import Layout from "../components/layout";
import { useParams, useNavigate } from "react-router-dom";
import MemberCard from "../components/MemberCard";
import html2canvas from "html2canvas";
import jsPDF from "jspdf";
import { Modal, Input } from "antd"; // Import Ant Design components
import "../index.css";

import picPlaceholder from "../components/people.jpg";

const MemberExitDetail = () => {
  const { matricule } = useParams();
  const [member, setMember] = useState("");
  const [familyHead, setFamilyHead] = useState(null); // State for family head data
  const [history, setHistory] = useState("");
  const [entryTime, setEntryTime] = useState("");
  const [exitTime, setExitTime] = useState("");
  const [isPrintLaunched, setIsPrintLaunched] = useState(false);
  const [isDataLoaded, setIsDataLoaded] = useState(false);
  const [durationMinutes, setDurationMinutes] = useState(false);
  const [durationSeconds, setDurationSeconds] = useState(false);
  const [durationHour, setDurationHour] = useState(false);

  const [restDays, setRestDays] = useState(0); // Default rest days state
  const [restEndDate, setRestEndDate] = useState(0); // Default rest days state

  const [restInputVisible, setRestInputVisible] = useState(true); // Modal visibility
  const [restInputValue, setRestInputValue] = useState(""); // Store rest days input value

  const ticketRef = useRef(null);
  const navigate = useNavigate();

  // ************  download the ticket into pdf ****************
  const handleDownloadPDF = async () => {
    const input = ticketRef.current;
    if (input) {
      const canvas = await html2canvas(input);
      const imgData = canvas.toDataURL("image/png");
      const pdf = new jsPDF();
      const imgProps = pdf.getImageProperties(imgData);
      const pdfWidth = pdf.internal.pageSize.getWidth();
      const pdfHeight = (imgProps.height * pdfWidth) / imgProps.width;
      const x = (pdf.internal.pageSize.getWidth() - pdfWidth) / 2;
      pdf.addImage(imgData, "PNG", 75, 10, pdfWidth, pdfHeight); // 10 units from the top
      pdf.save("ticket.pdf");
    }
  };

  // ************  print ticket ****************
  const handlePrint = () => {
    window.print();
  };

  // Handle rest days submission
  const handleRestDaysSubmit = async () => {
    const days = restInputValue ? parseInt(restInputValue) : 0;
    const restEndDate = new Date();
    restEndDate.setDate(restEndDate.getDate() + days);
    const formattedDate = restEndDate.toISOString().split("T")[0]; // Format end date

    setRestDays(days);
    setRestInputVisible(false); // Close the modal

    // Send rest days data to the backend
    try {
      const response = await fetch(
        `${process.env.REACT_APP_API_URL}/auth/store-rest-days`,
        {
          method: "POST",
          headers: {
            Authorization: "Bearer " + localStorage.getItem("token"),
            "Content-Type": "application/json",
          },
          body: JSON.stringify({
            matricule,
            restDays: days,
            restEndDate: formattedDate,
          }),
        }
      );

      const parseRes = await response.json();
      if (!parseRes.success) {
        console.error("Error storing rest days:", parseRes.message);
      }
    } catch (error) {
      console.error("Error:", error);
    }
  };

  useEffect(() => {
    console.log(matricule);
    const fetchMember = async () => {
      try {
        const response = await fetch(
          `${process.env.REACT_APP_API_URL}/auth/member-detail-exit`,
          {
            headers: {
              Authorization: "Bearer " + localStorage.getItem("token"),
              "Content-Type": "application/json",
            },
            method: "POST",
            body: JSON.stringify({ matricule }),
          }
        );

        const parseRes = await response.json();
        if (parseRes.success === true) {
          setMember(parseRes.data.member);
          setHistory(parseRes.data.history);
          setEntryTime(parseRes.data.entry);
          setExitTime(parseRes.data.exit);
          setDurationMinutes(parseRes.data.durationMinute);
          setDurationSeconds(parseRes.data.durationSecond);
          setDurationHour(parseRes.data.durationHour);
          setIsDataLoaded(true);
        } else if (parseRes.message === "NOT AUTHORIZED") {
          localStorage.clear();
          navigate("/login");
        } else {
          console.log("Member not recognized");
        }
      } catch (error) {
        console.error("Error:", error);
      }
    };
    fetchMember();
  }, [matricule]);

  // useEffect(() => {
  //   if (isDataLoaded && !isPrintLaunched) {
  //     setIsPrintLaunched(true);
  //     window.print();
  //   }
  // }, [isDataLoaded, isPrintLaunched]);

  return (
    <Layout>
      <div className="px-5 mt-3">
        <div className="d-flex mb-3 justify-content-center">
          <h3 className="page-title">Informations du patient</h3>
        </div>

        <div className="container">
          <div key={member.matricule}>
            <div className="d-flex jusfify-content-between">
              <p>
                {member.photo ? (
                  <img
                    src={`http://localhost:3000/Images/Adherants/${member?.photo}`}
                    className="member_photo_detail"
                    alt=""
                  />
                ) : (
                  <img className="member_photo_detail" src={picPlaceholder} />
                )}
              </p>

              <div>
                <p className="member-detail-name">
                  {member.prenom} {member.nom} {"("}
                  <td>
                    {new Date(member.date_de_naissance).toLocaleDateString(
                      "fr-FR"
                    )}
                  </td>
                  {")"}
                </p>
                <div>
                  <p className="text-left-value">
                    <span className="text-left-title">Matricule: </span>
                    {member.matricule}
                  </p>
                  <p className="text-left-value">
                    <span className="text-left-title">Adresse:</span>
                    {member.addresse ? member.addresse : "N/A"}
                  </p>
                </div>
              </div>
              <div className="div-tel-soc">
                <p className="text-left-value">
                  <span className="text-left-title">Téléphone:</span>
                  {member.telephone ? member.telephone : "N/A"}
                </p>
                <p className="text-left-value">
                  <span className="text-left-title">Société:</span>
                  {member.societe ? member.societe : "N/A"}
                </p>
              </div>
            </div>
            {/* <div className="d-flex justify-content-around">
              <p className="text-left-value">
                <span className="text-left-title">Marié(e):</span>{" "}
                {member.ismarried === true ? "Yes" : "No"}
              </p>
              <p className="text-left-value">
                <span className="text-left-title"> Family Head: </span>
                {member.is_family_head === true ? "Yes" : "No"}
              </p>
              <p className="text-left-value">
                <span className="text-left-title"> Enfants: </span>
                {member.haskids === true ? "Yes" : "No"}
              </p>
            </div> */}
            {member && (
              <MemberCard memberData={member} key={member.matricule} />
            )}
          </div>
          {history && (
            <div className="mt-4 ticket-print" ref={ticketRef}>
              <h1>ESIA</h1>
              <h4>Ticket Information</h4>
              <p className="first">
                <span className="ticket-subtitle">
                  <strong>Patient:</strong>
                </span>{" "}
                {member.prenom} {member.nom}
              </p>
              <p>
                <span className="ticket-subtitle">
                  <strong>Ste du patient:</strong>
                </span>{" "}
                {member.societe}
              </p>
              <p>
                <span className="ticket-subtitle">
                  <strong>Heure d'entrée:</strong>
                </span>{" "}
                {new Date(entryTime).toLocaleDateString()}{" "}
                {new Date(entryTime).toLocaleTimeString()}
              </p>
              <p>
                <span className="ticket-subtitle">
                  <strong>Heure de sortie:</strong>
                </span>{" "}
                {new Date(exitTime).toLocaleDateString()}{" "}
                {new Date(exitTime).toLocaleTimeString()}
              </p>
              <p>
                <span className="ticket-subtitle">
                  <strong>Durée:</strong>
                </span>{" "}
                {durationHour} : {durationMinutes} : {durationSeconds}
              </p>
              <p>
                <span className="ticket-subtitle">
                  <strong>Adresse:</strong>
                </span>{" "}
                {history.addresse}
              </p>

              <p>
                <span className="ticket-subtitle">
                  <strong>Agent:</strong>
                </span>{" "}
                {history.prise_en_charge_noms}
              </p>
              <p>
                <span className="ticket-subtitle">
                  <strong>Repos :</strong>
                </span>{" "}
                {restDays} jours
              </p>
            </div>
          )}
        </div>

        <div className="d-flex justify-content-center mt-3">
          <button onClick={handleDownloadPDF} className="btn btn-primary">
            Télécharger ticket en PDF
          </button>
          <button onClick={handlePrint} className="btn btn-secondary ml-2">
            Imprimer le ticket
          </button>
        </div>

        {/* Ant Design Modal for rest days input */}
        <Modal
          title="Rest Days"
          visible={restInputVisible}
          onOk={handleRestDaysSubmit}
          onCancel={() => setRestInputVisible(false)}
        >
          <p>How many days of rest?</p>
          <Input
            type="number"
            value={restInputValue}
            onChange={(e) => setRestInputValue(e.target.value)}
            placeholder="Enter number of rest days"
          />
        </Modal>
      </div>
    </Layout>
  );
};

export default MemberExitDetail;
